var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryuppar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 196,
    viewBox: "0 0 261 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.0058 17.8874C49.3085 25.2157 14.7114 20.9409 0 17.8874V169.797C0 188.729 14.2041 194.479 21.3061 194.988C85.9854 195.752 219.91 196.82 238.172 194.988C256.434 193.156 261 177.431 261 169.797V27.0478C239.694 20.9408 189.624 7.35294 159.796 1.8567C122.51 -5.01359 95.8775 8.727 70.0058 17.8874Z",
    fill: "#8CC9DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryuppar);
export default __webpack_public_path__ + "static/media/countryuppar.2a77f482de66494b92e5018526de931b.svg";
export { ForwardRef as ReactComponent };